// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__240ek","content":"RecentSearches_content__3Zw1q"};